/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Menu Icon
 */
import _ from 'lodash';
import { Table, PeopleSafe, Wallet, ListBottom, FileFocus, User, Palace, ChartHistogramTwo } from '@icon-park/react';

import AllCodes from 'components/app/icons/AllCodes';
import Claims from 'components/app/icons/Claims';
import FavoriteCodes from 'components/app/icons/FavoriteCodes';
import PatientPayments from 'components/app/icons/PatientPayments';
import InsurancePayments from 'components/app/icons/InsurancePayments';

const CUSTOM_ICONS = {
	AllCodes,
	Claims,
	FavoriteCodes,
	PatientPayments,
	InsurancePayments,
};

/**
 * Icon Map
 */
const ICON_MAP: Menu.IconMap = {
	Table,
	PeopleSafe,
	Wallet,
	ListBottom,
	FileFocus,
	User,
	Palace,
	ChartHistogramTwo,
	...CUSTOM_ICONS,
};

/**
 * Get Menu Icon
 * @param {string} icon - Icon
 */
const getMenuIcon = (icon: string): React.ReactNode => {
	const Item = _.get(ICON_MAP, icon);

	if (Item) {
		return <Item size={16} />;
	}
	return null;
};

export { getMenuIcon };
